import ValidationService from "../app/ValidationService";

export function validate(data, storePath, options) {
    const validationResult = { validations: [], validationSuccess: true };
    executeValidations(data, storePath, validationResult, options);
    return validationResult;
}

function executeValidations(
    data,
    storePath,
    validationContainer = { validations: [], validationSuccess: true },
    options = {}
) {
    //hidden entities do not need validations
    if (isHidden(data)) {
        return validationContainer;
    }
    //the validation will be executed depend on the component type
    //future evolution
    let componentType = getComponentType(data);
    //validate entity
    //message and validity will be returned if validation failed
    let validatedData = validateDependOnType(data, componentType, options);
    //if validation failed, save component path
    //that will be used to set validity
    if (validatedData.hasOwnProperty("failedValidations")) {
        let validationPathAndMessage = {};
        validationPathAndMessage.state = {};
        validationPathAndMessage.state = validatedData;
        validationPathAndMessage.path = Array.from(storePath);
        validationContainer.validations.push(validationPathAndMessage);
        if (validatedData.hasOwnProperty("valid") && validatedData.valid === false) {
            validationContainer.validationSuccess = validatedData.valid;
        }
    }
    //enum components' entities do not need validation
    if (isEnum(componentType) || isMultiEnum(componentType)) {
        return validationContainer;
    }

    //validate sub entities
    if (data.entities) {
        //memory optimization, using the same array for each nested entity
        storePath.push("entities");
        data.entities.forEach((entity, index) => {
            storePath.push(index);
            executeValidations(entity, storePath, validationContainer, options);
            storePath.pop();
        });
        storePath.pop();
    }
}

function validateDependOnType(entity, componentType, options = {}) {
    //we are expecting not to pass all properties
    //only validationOptions
    let entityProperties = entity.properties || {};
    let toValidate = typeof entityProperties.value !== "undefined" ? entityProperties.value : "";
    if (isMultiEnum(componentType)) {
        toValidate = entityProperties.value || [];
    }

    // Temporary fix / workaround for supporting required validation for the file upload component.
    // When wa file upload component is been validated, the the value that is been checked is not a string,
    // nor array or boolean. Instead this value is an object. In this case the required validation always passes.
    // In this case the validation has to be performed on the files property, because if it is empty this means that,
    // there are no files attached for the required file upload.
    // This code should be removed in future, when refactoring the file upload component or the validation service.
    if (isFile(toValidate)) {
        toValidate = toValidate.files;
    }

    return ValidationService.executeValidation(toValidate, entity, options);
}

function isEnum(componentType) {
    return componentType === "enum";
}

function isMultiEnum(componentType) {
    return componentType === "multiEnum";
}

function isFile(componentType) {
    if (!componentType) {
        return false;
    }
    return componentType.hasOwnProperty("files");
}

//two types of hidden containers
//1: property "hidden": true
//2: property "validate": false
//3: property "visible": false
//4: property "visible": true && "submitData": "never"
function isHidden(entity) {
    let entityProperties = entity.properties || {};
    if (entityProperties.hidden) {
        return true;
    }
    if (entityProperties.validate === false) {
        return true;
    }
    if (entityProperties.visible === false) {
        return true;
    }
    if (entityProperties.hasOwnProperty("visible") && entityProperties.submitData === "never") {
        return true;
    }
    return false;
}

//we are expecting evolution from BE to provide the data type
function getComponentType(entity) {
    //default entity data type
    //TODO for now BE use classifiers to define dataTypes...
    //there are still custom project components with specific siren format
    //we can not rely on the class position
    let entityClass = entity.class || [];
    let dataType;
    if (entityClass.length > 1) {
        dataType = entityClass[1];
    }
    if (entityClass.includes("enum")) {
        dataType = "enum";
    }
    if (entityClass.includes("multiEnum")) {
        dataType = "multiEnum";
    }

    let entityProperties = entity.properties || {};
    //currently BE sends data type as second classifier
    return entityProperties.dataType || dataType;
}
